export const VIEWS = {
    ABOUT: 'ABOUT',
    PORTFOLIO: 'PORTFOLIO',
    RESUME: 'RESUME',
    BOT: 'BOT',
}